import {FC, SVGProps} from 'react';

export const RocketBadgeIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden {...props}>
		<rect width="16" height="16" rx="8" fill="black" />
		<path
			d="M4.47656 5.29492V5.97354L8.47729 6.35517L12.0038 6.65986C12.025 6.6614 12.025 6.69371 12.0038 6.69525L8.47729 7.00609L4.47656 7.39542V8.60493L8.47729 8.99425L12.0038 9.3051C12.025 9.30664 12.025 9.33895 12.0038 9.34049L8.47729 9.64518L4.47656 10.0268V10.7054L12.478 9.92832V8.71573L8.47729 8.32794L4.93257 8.01556C4.91129 8.01402 4.91129 7.98171 4.93257 7.98017L8.47729 7.66779L12.478 7.28V6.06741L4.47656 5.29492Z"
			fill="#F3F3F3"
		/>
	</svg>
);
